// const { refreshToken } = useRefreshTokenState()

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    accessToken: null,
    refreshToken: '',
    refreshTokenDeviceId: null,
    invitedReward: false,
    deviceId: null,
    error: false,
    postToken: '',
    isNewUser: true
  }),

  getters: {
    token() {
      return this.accessToken
    },
    isAuthenticated() {
      return this.refreshToken !== null
    },
    localStorageAccess() {
      if (window.localStorage) {
        return true
      } else {
        return false
      }
    },
  },

  actions: {
    setAccessToken(accessToken) {
      this.accessToken = accessToken
      // if (this.localStorageAccess) {
      //   localStorage.setItem('accessToken', accessToken)
      // }
    },
    setRefreshToken(refreshToken) {
      const RuntimeConfig = useRuntimeConfig()
      const user = useUserStore()
      this.refreshToken = refreshToken
      if (RuntimeConfig.public.DEV_MODE === 'development') {
        if (this.localStorageAccess) {
          localStorage.setItem(
            'refreshToken',
            '7da7b0c6-7877-4bfb-bf31-94c2dee8dd3a',
          )
        }
      }
    },

    async auth() {
      const api = useApi()
      const response = await api.register()
      this.setAccessToken(response.accessToken)
      this.setRefreshToken(response.refreshToken)
      this.invitedReward = response?.invitedReward
    },

    async refreshRequest() {
      const api = useApi()
      try {
        const response = await api.refreshToken(this.refreshToken)
        this.setAccessToken(response.accessToken)
      } catch (e) {
        console.log(e)
      }
    },

    setRefreshTokenFromLocalStorage() {
      if (this.localStorageAccess) {
        const refreshToken = localStorage.getItem('refreshToken')
        if (refreshToken !== null) {
          this.setRefreshToken(refreshToken)
        }
      }
    },

    async refreshAuth() {
      // const user = useUserStore()
      const api = useApi()
      // // const accessToken = localStorage.getItem('accessToken')
      if (this.refreshToken !== null) {
        await this.refreshRequest()
        if (this.accessToken) {
          // await user.getUser()
          await api.addFriend()
        }
      }
    },

    setDeviceId() {
      const urlParams = new URLSearchParams(window.location.search)
      const uid = urlParams.get('uid')
      if (uid) {
        this.deviceId = uid
      }
    },

    async refreshTokenDeviceId() {
      if (this.deviceId && !this.refreshToken) {
        const api = useApi()
        try {
          const res = await api.refreshTokenDeviceId(this.deviceId)
          this.setRefreshToken(res.refreshToken)
        } catch (error) { }
      }
    },
  },
})
